module.exports = __webpack_public_path__ + "static/img/sapwoodCellars_logo.33b5f4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sapwoodCellars_logo.png
// module id = 305
// module chunks = 1